import { motion } from "framer-motion";

const facts = [
  { n: "Producción", t: "Sistematizada, con capacidad y frío resueltos." },
  { n: "Franquicia", t: "Modelo llave en mano, procesos y contratos listos." },
  { n: "Expansión", t: "Local nuevo, distribución y pasta al paso en marcha." },
];

const MammaMomento = () => {
  return (
    <section
      id="momento"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(217 61% 10%), hsl(220 69% 2%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <span
            className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-5 block"
            style={{ color: "#7ab7fd" }}
          >
            Dónde estás hoy
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1]">
            Construiste una
            <br />
            <span style={{ color: "#7ab7fd" }}>base impecable.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="space-y-5 text-base md:text-lg text-white/75 leading-relaxed mb-12"
        >
          <p>
            En tres años levantaste una fábrica artesanal con producción ordenada,
            procesos medidos y un sistema que funciona. Tenés tres puntos de venta,
            la franquicia ya documentada y lista, y un local nuevo en camino. La
            parte más difícil de cualquier negocio —que{" "}
            <span className="text-white font-medium">opere bien</span>— ya la
            resolviste.
          </p>
          <p>
            Sos, en tus propias palabras,{" "}
            <span className="font-display italic" style={{ color: "#7ab7fd" }}>
              manufactura artesanal eficiente
            </span>
            . Ese es tu terreno firme. Y es exactamente por eso que lo que sigue
            tiene tanto potencial.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5 mb-20">
          {facts.map((f, i) => (
            <motion.div
              key={f.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }}
              className="rounded-2xl border border-white/10 p-6"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <p className="font-display text-lg font-semibold text-white mb-2">
                {f.n}
              </p>
              <p className="text-sm text-white/65 leading-relaxed">{f.t}</p>
            </motion.div>
          ))}
        </div>

        {/* La brecha */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <span
            className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-5 block"
            style={{ color: "#7ab7fd" }}
          >
            Lo que falta
          </span>
          <h3 className="font-display text-2xl md:text-4xl font-bold text-white leading-[1.15]">
            Y aún así, la franquicia todavía no cierra.
          </h3>
        </motion.div>

        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="rounded-xl p-6 md:p-7 border-l-4 mb-8"
          style={{ borderColor: "#4F46E5", background: "rgba(79,70,229,0.08)" }}
        >
          <p className="font-display italic text-lg md:text-2xl text-white leading-snug">
            «Cuesta cerrar los primeros porque no se conoce la marca, porque{" "}
            <span style={{ color: "#7ab7fd" }}>todavía no está instalada</span>.»
          </p>
        </motion.blockquote>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="space-y-6"
        >
          <p className="text-base md:text-lg text-white/75 leading-relaxed">
            Ese es el punto exacto —y lo dijiste vos—. No es un problema de
            operación: eso lo tenés resuelto. Es que un inversor no firma por un
            manual de procesos. Firma por una marca en la que cree. Hoy Mamma
            Pasta es una intuición extraordinaria que vive en tu cabeza y en las
            manos de tu vieja: el legado, el sabor, la calidad que no negociás.
            Pero todavía{" "}
            <span className="text-white font-medium">no es un sistema</span> que
            otro pueda comprar, replicar y sostener.
          </p>
          <p className="font-display text-xl md:text-3xl text-white text-center leading-snug pt-4">
            El vehículo está construido.
            <br />
            <span className="italic" style={{ color: "#7ab7fd" }}>
              Falta el motor.
            </span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default MammaMomento;
